import { useTranslation } from 'react-i18next';
import { useSupportEmail } from '@/hooks/useSupportEmail';

export default function SupportCard() {
  const { t } = useTranslation();
  const supportEmail = useSupportEmail();

  return (
    <div className="rounded-lg border border-accent-200 bg-accent-50 p-6">
      <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-500 text-background-50">
        <i className="ri-customer-service-2-line text-lg"></i>
      </span>
      <h2 className="mt-4 font-heading text-base font-semibold text-foreground-950">
        {t('dashboard.support')}
      </h2>
      <p className="mt-2 text-sm leading-relaxed text-foreground-700">
        {t('dashboard.supportText')}
      </p>
      <a
        href={`mailto:${supportEmail}`}
        className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-accent-800 underline-offset-4 hover:underline"
      >
        <i className="ri-mail-line"></i>
        {supportEmail}
      </a>
    </div>
  );
}